import { UX2 } from '@wsb/guac-widget-core';

const { Color } = UX2.utils;

// CSS keywords core's Color factories don't parse but that can appear in
// legacy/stored values.
const NAMED_HEX = { black: '#000000', white: '#ffffff' };

// Parse any CSS color string into a core Color instance, or null. Core's Color
// has no single `parse()` — it exposes per-format factories — so this
// centralizes the format detection every caller would otherwise re-implement.
export function parseColor(input) {
  if (input instanceof Color) return input;
  if (typeof input !== 'string') return null;
  const s = input.trim().toLowerCase();
  try {
    if (NAMED_HEX[s]) return Color.fromHex(NAMED_HEX[s]);
    if (s.charAt(0) === '#') return Color.fromHex(s);
    if (s.indexOf('rgb') === 0) return Color.fromRGB(s);
    if (s.indexOf('hsl') === 0) return Color.fromHSL(s);
  } catch (e) {
    /* unparseable → null below */
  }
  return null;
}

// True when a color is light enough to want DARK text on it. Uses Color's
// HSLuv perceptual lightness (0–100); `threshold` is on that 0–100 scale.
// Unparseable → treat as light (dark text is the safe default on the common
// white/neutral surfaces).
export function isLightColor(input, threshold = 50) {
  const color = parseColor(input);
  if (!color) return true;
  return color.lightness >= threshold;
}
